import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import cx from "classnames";
import PropTypes from "prop-types";
import {
  checkIsValidForm,
  updateErrorsForm,
} from "../../services/manageValidation";
import Button from "../../components/Button/Button";
import modals from "../../components/ModalAdditionResult/modals"; //TO DO REFACTOR WE DON'T NEED THIS
import FormGetItemByPropValue from "../../components/FormGetItemByPropValue/FormGetItemByPropValue";
import FormGetItemByKey from "../../components/FormGetItemByKey/FormGetItemByKey";
import SpotForm from "../../containers/SpotForm/SpotForm";
import { addSpot } from "../../services/api";
import TYPE from "../../constants/searchType";
import {
  setIsLoading,
  setSpotToEdit,
  getSpotByTypeKey,
} from "../../reduxSetup/action";
import styles from "./SpotEditor.module.scss";

const SpotEditor = ({
  setIsLoading,
  setSpotToEdit,
  spotToEdit,
  getSpotByTypeKey,
  user,
}) => {
  const { lng } = useParams()
  const [spotKey, setSpotKey] = useState("");
  const [type, setType] = useState("NGO");
  const [stepStatus, setStepStatus] = useState(false)

  const clearAll = ({
    setOrganizationFields,
    setBusinessFields,
    setValidationError,
    setName,
    setCategory,
    setWebsite,
    setAddress,
    setDescription,
    setLogo,
    setEmail,
    setPhotos,
    setCountries,
    setUsState,
    setRelatedOrganizations,
    setLinks,
    setProblem,
    setSolutions,
    setTimeline,
    setSpotsByName,
    setSpotsByUrl,
    setTitleSeo,
    setDescriptionSeo,
    setPhone,
    setLinkedin,
    setFacebook,
    setFoundationDate,
    setEmployees,
    setLanguages
  }) => {
    const logoHTML = document.getElementById("addLogo");
    setOrganizationFields && setOrganizationFields([]);
    setBusinessFields && setBusinessFields([]);
    setValidationError([]);
    setName("");
    setCategory && setCategory([]);
    setWebsite && setWebsite("");
    setAddress("");
    setDescription && setDescription("");
    setCountries && setCountries([]);
    setUsState && setUsState([]);
    setLogo && setLogo("");
    setEmail("");
    setSpotToEdit(false);
    setSpotKey("");
    setPhotos && setPhotos([""]);
    setProblem && setProblem("");
    setSolutions && setSolutions("")
    setTimeline && setTimeline("");
    setRelatedOrganizations && setRelatedOrganizations([""]);
    setLinks && setLinks([""]);
    logoHTML && (logoHTML.value = "");
    setSpotsByName && setSpotsByName([]);
    setSpotsByUrl && setSpotsByUrl([]);
    setTitleSeo && setTitleSeo("");
    setDescriptionSeo && setDescriptionSeo("");
    setPhone && setPhone('');
    setLinkedin && setLinkedin('');
    setFacebook && setFacebook('');
    setFoundationDate && setFoundationDate('');
    setEmployees && setEmployees([]);
    setLanguages && setLanguages([]);
  };

  const handleSubmit = ({
    toggleModal,
    name,
    setValidationError,
    countries,
    usState,
    website,
    address,
    email,
    organizationFields,
    description,
    problem,
    solutions,
    timeline,
    logo,
    businessFields,
    originalId,
    links,
    key,
    category,
    photos,
    relatedOrganizations,
    setSpotsByName,
    setCountries,
    setUsState,
    setSpotsByUrl,
    titleSeo,
    descriptionSeo,
    setTitleSeo,
    setDescriptionSeo,
    relatedHotSpots,
    userOwner,
    phone,
    employeesNumber,
    languages,
    socialMedia,
    foundationDate,
    source,
    addresses,
    city,
    line2,
    postcode,
    setOrganizationFields,
    setBusinessFields,
    setName,
    setCategory,
    setWebsite,
    setAddress,
    setPhotos,
    setProblem,
    setSolutions,
    setTimeline,
    setRelatedOrganizations,
    setLinks,
    setDescription,
    setLogo,
    setEmail,
    setKey,
    setPhone,
    setLinkedin,
    setFacebook,
    setFoundationDate,
    setEmployees,
    setLanguages,

  }) => {
    const originalType = spotToEdit?.type;
    const state = {
      name,
      countries,
      usState,
      website,
      address,
      organizationFields,
      businessFields,
      description,
      category,
      type,
      email,
      photos: photos,
      problem,
      solutions,
      timeline,
      links: links,
      titleSeo,
      descriptionSeo

    };

    if (!checkIsValidForm({ state })) {
      updateErrorsForm({
        state,
        setValidationError,
      });

      return;
    }

    setIsLoading(true);
    const fields = () => {
      switch (type) {
        case "NGO":
          return organizationFields;
        case "business":
          return businessFields;
        default:
          return null;
      }
    };

    addSpot({
      name,
      country: countries?.[0],
      state: countries?.[0] === "USA" ? usState?.[0] || "" : "",
      link: website,
      address,
      fields: fields(),
      description,
      type,
      logo,
      email,
      category,
      language: lng,
      originalId,
      originalType,
      status: "onreview",
      key,
      author: user.email,
      photos,
      problem,
      solutions,
      timeline,
      relatedOrganizations,
      relatedHotSpots,
      links,
      titleSeo,
      descriptionSeo,
      userOwner,
      phone,
      employeesNumber,
      languages,
      socialMedia,
      foundationDate,
      source,
      addresses,
      city,
      line2,
      postcode,
    })
      .then((response) => {
        if (response?.status === 200) {
          toggleModal(modals.organization);
          clearAll({
            setOrganizationFields,
            setBusinessFields,
            setValidationError,
            setName,
            setCategory,
            setWebsite,
            setAddress,
            setDescription,
            setProblem,
            setSolutions,
            setTimeline,
            setCountries,
            setLogo,
            setEmail,
            setKey,
            setPhotos,
            setRelatedOrganizations,
            setLinks,
            setSpotsByName,
            setSpotsByUrl,
            setTitleSeo,
            setDescriptionSeo,
            setPhone,
            setLinkedin,
            setFacebook,
            setFoundationDate,
            setEmployees,
            setLanguages
          });
          setStepStatus(true)
        }

        if (!response) {
          toggleModal(modals.wrongAddress);
        }
      })

      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    spotToEdit && setType(spotToEdit.type)
  }, [spotToEdit])
  return (
    <div className={styles.addNewContainer}>
      <h1 className={styles.title}>Create new or edit a spot</h1>
      <FormGetItemByPropValue getItemToEdit={getSpotByTypeKey} />
      <div className={styles.formContainer}>
        <div className={styles.buttonsContainer}>
          {TYPE.filter((item) => !item.value.includes("New") && !item.value.includes("Spot")).map((item) => {

            return (
              <Button
                key={item.value}
                className={cx(styles.typeButton, {
                  [styles.activeButton]: type === item.value,
                })}
                onClick={() => {
                  setType(item.value)
                  setStepStatus(true)
                }}
              >
                {item.label}
              </Button>
            )
          })}
        </div>
        <FormGetItemByKey
          type={type}
          itemKey={spotKey}
          setItemKey={setSpotKey}
          getItemToEdit={getSpotByTypeKey}
        />
        <SpotForm
          type={type}
          spotToEdit={spotToEdit}
          handleSubmit={handleSubmit}
          clearAll={clearAll}
          isSpotEditor={true}
          lng={lng}
          getItemToEdit={getSpotByTypeKey}
          stepStatus={stepStatus}
        />
      </div>
    </div>
  );
};

SpotEditor.propTypes = {
  match: PropTypes.object,
  setIsLoading: PropTypes.func,
  setSpotToEdit: PropTypes.func,
  spotToEdit: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  getSpotByTypeKey: PropTypes.func,
  user: PropTypes.object,
};
SpotEditor.dafaultProps = {
  setIsLoading: () => { },
  email: "",
};

const mapStateToProps = ({ companies, user }) => {
  const { spotToEdit } = companies;
  return {
    spotToEdit,
    user,
  };
};

const mapDispatchToProps = {
  setIsLoading,
  setSpotToEdit,
  getSpotByTypeKey,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpotEditor);
